<template>
	<div>
		<div :class="['switch-title', options.wrapperClass]">
			{{ options.label }}
			<span v-if="options.tooltip" class="info"></span>
		</div>
		<div class="switch-element">
			<input
				type="checkbox"
				hidden="hidden"
				:id="generatedId"
				:checked="getDataByGroup(options.inputGroup, index)[name]"
				@change="onChange"
				data-hj-allow
			/>
			<label class="text switch-on" :for="generatedId">{{ options.choises.true }}</label>
			<label class="switch" :for="generatedId"></label>
			<label class="text switch-off" :for="generatedId">{{ options.choises.false }}</label>
		</div>
	</div>
</template>

<script>
import shared from '@/mixins/shared';

export default {
	mixins: [shared],
};
</script>
